import { render, staticRenderFns } from "./DataCorrectionApplications.vue?vue&type=template&id=6a6e24d6&scoped=true&"
import script from "./DataCorrectionApplications.vue?vue&type=script&lang=js&"
export * from "./DataCorrectionApplications.vue?vue&type=script&lang=js&"
import style0 from "./DataCorrectionApplications.vue?vue&type=style&index=0&id=6a6e24d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6e24d6",
  null
  
)

export default component.exports